import { Gear } from '@phosphor-icons/react'
import { useContext } from 'react'
import { useHistory } from 'react-router-dom'

import GoogleDriveLogo from '@/assets/logos/google-drive-logo.jpg'
import { IntegrationsContext } from '@/utils/IntegrationsContext'

import { IntegrationCard } from '../IntegrationCard'

export const GoogleDriveIntegrationComponent = () => {
  const history = useHistory()

  const {
    isLoadingOAuth,
    isLoadingDisconnect,
    onDisconnect,
    oauthSignIn,
    googleUserDetails,
    googleIntegrationActive,
  } = useContext(IntegrationsContext)

  const hasGoogleEmail = Boolean(googleUserDetails?.email)
  return (
    <IntegrationCard.Root>
      <IntegrationCard.Header>
        <div className="flex items-center">
          <IntegrationCard.Image src={GoogleDriveLogo} />
          <IntegrationCard.Title>Google Drive</IntegrationCard.Title>
        </div>
        <IntegrationCard.Status isConnected={googleIntegrationActive} />
      </IntegrationCard.Header>
      <IntegrationCard.Content className="justify-between">
        <IntegrationCard.Description>
          Sync PDF files to Google Drive
        </IntegrationCard.Description>
        {hasGoogleEmail ? (
          <IntegrationCard.Mail>
            {googleUserDetails?.email}
          </IntegrationCard.Mail>
        ) : null}
      </IntegrationCard.Content>
      <IntegrationCard.Footer>
        <IntegrationCard.Button
          danger={googleIntegrationActive}
          loading={isLoadingDisconnect || isLoadingOAuth}
          onClick={googleIntegrationActive ? onDisconnect : oauthSignIn}
          type={!googleIntegrationActive ? 'link' : 'primary'}
        >
          {googleIntegrationActive ? 'Disconnect' : 'Connect'}
        </IntegrationCard.Button>
        <IntegrationCard.Button
          onClick={() => history.push('/settings/google-drive')}
        >
          <Gear className="text-lg" /> Settings
        </IntegrationCard.Button>
      </IntegrationCard.Footer>
    </IntegrationCard.Root>
  )
}
